import { render, staticRenderFns } from "./CardSortCombo.vue?vue&type=template&id=7f6c5bb4&scoped=true"
import script from "./CardSortCombo.vue?vue&type=script&lang=js"
export * from "./CardSortCombo.vue?vue&type=script&lang=js"
import style0 from "./CardSortCombo.vue?vue&type=style&index=0&id=7f6c5bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c5bb4",
  null
  
)

export default component.exports